import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

export function VivoServicePage() {
  return (
    <ServicePageLayout
      seo={{
        title: "Vivo Repair Kochi - Vivo Service Center Kerala | Device Doctor",
        description: "Professional Vivo repair services in Kochi, Kerala. Expert Vivo device repair for V series, Y series, X series. Screen replacement, battery repair, camera issues, software problems. Quality service with warranty.",
        keywords: "vivo repair kochi, vivo service center kerala, vivo screen repair, vivo battery replacement, vivo repair vyttila, vivo camera repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "Vivo Repair Services", "brand": { "@type": "Brand", "name": "Vivo" } }
      }}
      hero={{
        title: "Vivo Service Centre in Kochi",
        subtitle: "The most reliable Vivo mobile service centre in Vyttila, Kochi. Our trained technicians provide expert repair using genuine Vivo parts.",
        stats: [{ value: '350+', label: 'Vivo Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/vivo-hero-bg.jpg",
        className: "bg-gradient-to-br from-indigo-500 to-purple-600"
      }}
      serviceList={{
        introParagraph: "Comprehensive repair solutions for all Vivo smartphone issues with genuine parts and expert technicians.",
        services: [
          { id: 'display', title: 'Display & Touchscreen Repairs', icon: 'ri-smartphone-line', image: '/assets/android-repair-new.jpg', description: 'Complete screen solutions for your Vivo phone.', subServices: [{ title: 'Screen Repairs', description: 'Solutions for cracked glass, flicker, and touch issues.', features: ['Screen replacement', 'Touch calibration', 'Ghost-touch fix', 'Backlight issues'] }] }
        ]
      }}
      features={{
        title: "Why Choose Device Doctor for Vivo Repairs",
        subtitle: "Experience the difference with Kerala's most trusted Vivo service center.",
        badgeText: "Why Choose Us",
        items: [
          { icon: 'ri-user-star-line', title: 'Certified Vivo technicians', description: 'Our team consists of certified professionals with hands-on expertise in Vivo repairs.' },
          { icon: 'ri-shield-check-line', title: '100% genuine Vivo parts', description: 'We use genuine parts to ensure your device maintains its original quality.' },
          { icon: 'ri-time-line', title: 'Same-day service', description: 'Most issues are completed within the same day for your convenience.' },
          { icon: 'ri-price-tag-3-line', title: 'Transparent pricing', description: 'No hidden fees. We provide upfront, honest pricing with free diagnostics.' },
          { icon: 'ri-truck-line', title: 'All-Kerala Courier Service', description: 'Convenient delivery service across Kerala for maximum accessibility.' },
          { icon: 'ri-award-line', title: '1-month service warranty', description: 'All repairs come with a comprehensive 1-month warranty.' }
        ]
      }}
      models={{
        title: "Vivo Models We Service",
        subtitle: "We service all Vivo smartphones, including Y-Series, V-Series, X-Series, and iQOO models.",
        categories: [
          { title: 'Y-Series Models', icon: 'ri-smartphone-line', models: ['Vivo Y20', 'Vivo Y33', 'Vivo Y53'], color: 'bg-indigo-500' },
          { title: 'V-Series Models', icon: 'ri-smartphone-fill', models: ['Vivo V20', 'Vivo V23', 'Vivo V27'], color: 'bg-purple-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: 'Rohit K.', location: 'Kochi', rating: 5, text: 'Display issue fixed the same day. Great team and genuine Vivo parts!', service: 'Screen Replacement' },
          { name: 'Divya S.', location: 'Aluva', rating: 5, text: 'Charging port repaired perfectly. Loved the fast delivery option from my hometown.', service: 'Charging Port Repair' }
        ]
      }}
      faq={{
        items: [
          { question: 'How long does a Vivo repair take?', answer: 'Most common repairs are completed the same day. Complex issues may take 1-2 business days.' },
          { question: 'Do you provide warranty after service?', answer: 'Yes, we offer a 1-month service warranty on all Vivo repairs.' }
        ]
      }}
      cta={{
        title: "Ready to Fix Your Vivo?",
        subtitle: "Get your Vivo phone repaired by Kerala's trusted service experts. Contact Device Doctor – Best Vivo Service Centre in Kochi.",
        themeColor: "purple"
      }}
    />
  );
}

export default VivoServicePage;